import { useEffect, useState } from "react";
import _ from "lodash";

import { postApiCommunicationTemplate } from "@src/api-new/generated-api";


type TemplateStatus = "idle" | "loading" | "success" | "error";

const getBodyHtml = (html: string) => new DOMParser().parseFromString(html, "text/html").body.innerHTML.trim();

export default function useCommunicationTemplate(templateName: string, enabled = true) {

  const [ status, setStatus ] = useState<TemplateStatus>("idle");
  const [ content, setContent ] = useState("");

  useEffect(() => {
    if (!enabled || status !== "idle") {
      return;
    }

    const fetchTemplate = async() => {
      setStatus("loading");
      try {
        const { actualResponseData } = await postApiCommunicationTemplate({ templateName });
        setContent(_.isString(actualResponseData) ? getBodyHtml(actualResponseData) : "");
        setStatus("success");
      }
      catch {
        setStatus("error");
      }
    };

    fetchTemplate();
  }, [ templateName, enabled, status ]);

  return {
    content,
    isLoading: enabled && (status === "idle" || status === "loading")
  };
}
